import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomFont, CustomFonts } from './custom.font';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { CustomFontsApi } from './custom-fonts.api';
import { tap } from 'rxjs/operators';

@Injectable()
export class CustomFontsService {
  public customFonts: Observable<CustomFonts>;
  private _customFonts: BehaviorSubject<CustomFonts> = new BehaviorSubject(new CustomFonts());


  constructor(private customFontsApi: CustomFontsApi) {
    this.customFonts = this._customFonts.asObservable();
  }

  getCurrentCustomFonts(): CustomFont[] {
    return this._customFonts.getValue().fonts;
  }

  getCustomFonts() {
    return this.customFontsApi.getCustomFonts().pipe(tap((fonts: CustomFonts) => {
      fonts.fonts = fonts.fonts
        .sort((a, b) => a.Name < b.Name ? -1 : a.Name > b.Name ? 1 : 0);
      this._customFonts.next(fonts);
    }));
  }

  addCustomFont(font: CustomFont) {
    return this.customFontsApi.addCustomFont(font).pipe(tap((customFont: CustomFont) => {
      this._customFonts.getValue().fonts.unshift(customFont);
      const fonts = new CustomFonts();
      fonts.fonts = this._customFonts.getValue().fonts
        .sort((a, b) => a.Name < b.Name ? -1 : a.Name > b.Name ? 1 : 0);
      this._customFonts.next(fonts);
    }));
  }

  deleteCustomFont(ids: string[]) {
    return this.customFontsApi.deleteCustomFont(ids).pipe(tap(() => {
      const customFont = this._customFonts.getValue().fonts.filter((font) => {
        return ids.every(f => f !== font.Id);
      });
      const customFonts = new CustomFonts();
      customFonts.fonts = customFont;
      this._customFonts.next(customFonts);
    }));
  }
}
